import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["backgroundColor", "baseUrl", "logo", "firstLevelLinks", "menuItems", "menuIcons", "showHamburger", "showLogoHamburger", "showHamburgerRight", "hamburgerOpenIcon", "hamburgerCloseIcon", "onMenuItemClick", "searchConfig"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/Header.js",
  _this = this;
import React, { useState } from 'react';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import MobileMenu from './MobileMenu';
import { testIdProps } from '../../helpers';
import { withTheme } from '../../core/ThemeProvider';
import styled, { css } from 'styled-components';
var StyledHeader = withTheme(styled.div.withConfig({
  displayName: "Header__StyledHeader",
  componentId: "sc-2xrfqi-0"
})(function (props) {
  return css(["display:flex;align-items:center;height:", ";background-color:", ";border-top:", ";box-shadow:", ";z-index:99999;@media (min-width:", "){height:", ";}"], props.coreTheme.header.mobileHeight, props.backgroundColor, props.coreTheme.header.borderTop, props.coreTheme.header.boxShadow, props.coreTheme.brk_md, props.coreTheme.header.desktopHeight);
}));
var Header = function Header(_ref) {
  var backgroundColor = _ref.backgroundColor,
    baseUrl = _ref.baseUrl,
    logo = _ref.logo,
    firstLevelLinks = _ref.firstLevelLinks,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    menuIcons = _ref.menuIcons,
    showHamburger = _ref.showHamburger,
    showLogoHamburger = _ref.showLogoHamburger,
    showHamburgerRight = _ref.showHamburgerRight,
    hamburgerOpenIcon = _ref.hamburgerOpenIcon,
    hamburgerCloseIcon = _ref.hamburgerCloseIcon,
    onMenuItemClick = _ref.onMenuItemClick,
    searchConfig = _ref.searchConfig,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHamburgerMenuOpen = _useState2[0],
    setIsHamburgerMenuOpen = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    menuHoverKey = _useState4[0],
    setMenuHoverKey = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    activeMenuItem = _useState6[0],
    setActiveMenuItem = _useState6[1];
  var _useState7 = useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    activeSubMenuItem = _useState8[0],
    setActiveSubMenuItem = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSearchActive = _useState10[0],
    setIsSearchActive = _useState10[1];
  var handleDesktopMenuMouseEnter = function handleDesktopMenuMouseEnter(key) {
    return setMenuHoverKey(key);
  };
  var handleDesktopMenuMouseLeave = function handleDesktopMenuMouseLeave() {
    return setMenuHoverKey(-1);
  };
  var handleHamburgerClick = function handleHamburgerClick() {
    return setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
  };
  var handleMobileAccordionHeaderClick = function handleMobileAccordionHeaderClick(menuKey, subKey) {
    setActiveMenuItem(menuKey);
    setActiveSubMenuItem(activeSubMenuItem !== subKey ? subKey : -1);
  };
  var onSearchIconClick = function onSearchIconClick() {
    setIsSearchActive(!isSearchActive);
  };
  var searchConfigOptions = Object.assign({
    showSearch: !!searchConfig,
    isActive: isSearchActive,
    onSearchIconClick: onSearchIconClick
  }, searchConfig);
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({
    backgroundColor: backgroundColor
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(MobileHeader, {
    baseUrl: baseUrl,
    logo: logo,
    menuIcons: menuIcons,
    onHamburgerClick: handleHamburgerClick,
    showHamburger: showHamburger,
    showHamburgerRight: showHamburgerRight,
    hamburgerOpenIcon: hamburgerOpenIcon,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(DesktopHeader, {
    baseUrl: baseUrl,
    logo: logo,
    firstLevelLinks: firstLevelLinks,
    menuItems: menuItems,
    menuIcons: menuIcons,
    menuHoverKey: menuHoverKey,
    onMenuMouseEnter: handleDesktopMenuMouseEnter,
    onMenuMouseLeave: handleDesktopMenuMouseLeave,
    onMenuItemClick: onMenuItemClick,
    searchConfigOptions: searchConfigOptions,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(MobileMenu, {
    baseUrl: baseUrl,
    backgroundColor: backgroundColor,
    activeSubMenuItem: activeSubMenuItem,
    activeMenuItem: activeMenuItem,
    firstLevelLinks: firstLevelLinks,
    isHamburgerMenuOpen: isHamburgerMenuOpen,
    logo: logo,
    menuItems: menuItems,
    onClose: handleHamburgerClick,
    onAccordionHeaderClick: handleMobileAccordionHeaderClick,
    showLogoHamburger: showLogoHamburger,
    showHamburgerRight: showHamburgerRight,
    hamburgerCloseIcon: hamburgerCloseIcon,
    onMenuItemClick: onMenuItemClick,
    searchConfigOptions: searchConfigOptions,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 7
    }
  }));
};
export default Header;